// Data seam: sphinx has no auth. There is exactly one actor — the operator —
// so auth state is a constant and the users:* mutations are no-ops.
//
// Decisions:
// - useAuthState → { isAuthenticated: true, isLoading: false } (static)
// - useCurrentUser → OPERATOR_USER (static; "skip" → undefined as before)
// - ensureUser / markOnboardingShown → resolved no-ops

export type OperatorUser = {
  _id: string;
  id: string;
  name: string;
  email: string;
  profilePictureUrl?: string;
  hasSeenOnboarding: boolean;
  hasCompletedOnboarding: boolean;
  isAnonymous: boolean;
  createdAt: number;
};

export const OPERATOR_USER: OperatorUser = {
  _id: "operator",
  id: "operator",
  name: "Operator",
  email: "operator@sphinx.local",
  profilePictureUrl: undefined,
  hasSeenOnboarding: true,
  hasCompletedOnboarding: true,
  isAnonymous: false,
  createdAt: 0,
};

const AUTH_STATE = { isAuthenticated: true, isLoading: false } as const;

/** `{ isAuthenticated, isLoading }` for the current actor. */
export function useAuthState(): { isAuthenticated: boolean; isLoading: boolean } {
  return AUTH_STATE;
}

/** Static operator — omit `args` (or pass `{}`) to read, `"skip"` to skip. */
export function useCurrentUser(
  args?: Record<string, never> | "skip"
): OperatorUser | undefined {
  return args === "skip" ? undefined : OPERATOR_USER;
}

const ensureUser = async (_args?: unknown): Promise<string> => OPERATOR_USER._id;
const markOnboardingShown = async (_args?: unknown): Promise<void> => {};

export function useEnsureUserMutation() {
  return ensureUser;
}

export function useMarkOnboardingShownMutation() {
  return markOnboardingShown;
}
